import { gql } from '@apollo/client';
import { UserFieldsFragment, UserLicenceFieldsFragment } from './fragments';

export const GET_USER = gql`
  query Me {
    me {
      ...UserFields
    }
  }
  ${UserFieldsFragment}
`;

export const GET_USER_PREFERENCES = gql`
  query GetUserPreferences {
    getUserPreferences {
      blog
      newsletter
      sparkyard
    }
  }
`;

export const GET_USER_LICENCES = gql`
  query GetUserLicences {
    getUserLicences {
      ...UserLicenceFields
    }
  }
  ${UserLicenceFieldsFragment}
`;
